import React, { Component } from 'react';

export default class GreenTriangle extends Component {
  render() {
    return (
      <svg width="18px" height="18px" viewBox="0 0 512 512" version="1.1">
        <title>triangle-filled</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="drop" fill="#689f38" transform="translate(32.000000, 42.666667)">
            <path
              d="M246.312928,5.62892705 C252.927596,9.40873724 258.409564,14.8907053 262.189374,21.5053731 L444.667042,340.84129 C456.358134,361.300701 449.250007,387.363834 428.790595,399.054926 C422.34376,402.738832 415.04715,404.676552 407.622001,404.676552 L42.6666667,404.676552 C19.1025173,404.676552 7.10542736e-15,385.574034 7.10542736e-15,362.009885 C7.10542736e-15,354.584736 1.93772021,347.288125 5.62162594,340.84129 L188.099293,21.5053731 C199.790385,1.04596203 225.853517,-6.06216498 246.312928,5.62892705 Z"
              id="Combined-Shape"></path>
          </g>
        </g>
      </svg>

      // <svg
      //     width="14px"
      //     height="14px"
      //     viewBox="0 0 128 128"
      //     xmlns="http://www.w3.org/2000/svg"
      //     aria-hidden="true"
      //     role="img"
      //     className="iconify iconify--noto"
      //     preserveAspectRatio="xMidYMid meet"
      //     fill="#000000"
      // >
      //     <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      //     <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      //     <g id="SVGRepo_iconCarrier">
      //         <circle cx="63.93" cy="64" r="60" fill="#689f38"></circle>
      //         <circle cx="60.03" cy="63.1" r="56.1" fill="#7cb342"></circle>
      //         <path d="M23.93 29.7c4.5-7.1 14.1-13 24.1-14.8c2.5-.4 5-.6 7.1.2c1.6.6 2.9 2.1 2 3.8c-.7 1.4-2.6 2-4.1 2.5a44.64 44.64 0 0 0-23 17.4c-2 3-5 11.3-8.7 9.2c-3.9-2.3-3.1-9.5 2.6-18.3z" fill="#aed581"></path>
      //     </g>
      // </svg>
    );
  }
}
